
import { useScenario} from "../../contexts/ScenarioContext"

import RevealTable from "../RevealTable"

const BreathingTabContent = () => {
    const { breathingFindings } = useScenario()
 
    
    return (
            <RevealTable
                title="Breathing"
                category="breathing"
                headings={["Assessments", "Current Value"]}
                rows={breathingFindings}
            />
    )
}

export default BreathingTabContent